import { invariant } from '@apollo/client/utilities/globals/invariantWrappers';
import {
  usePreBookingsPubSub,
  useServiceExecutionsPubSub,
  useStorePubSub,
  useStylistsPubSub,
} from 'drycut-apollo';
import { useAuth } from 'drycut-auth';

export default function StorePubSubInit(): React.ReactNode {
  const { currentSlug: slug } = useAuth();

  // This should never happen, but just in case.
  invariant(slug, 'currentSlug is required');

  // These calls will subscribe to the pubsub channels and update cached data in the
  // GetServiceExecutionsDocument, GetPreBookingsDocument and GetCheckedInStylistsDocument.
  useServiceExecutionsPubSub({ slug, callback: (broadcast) => console.log(broadcast) });
  usePreBookingsPubSub({ slug, callback: (broadcast) => console.log(broadcast) });
  useStylistsPubSub({ slug, callback: (broadcast) => console.log(broadcast) });

  // Also listen for changes in the store (waiting time is what we are interested in here)
  useStorePubSub({ slug });

  return null;
}
